export const defaultImageQuality = '40'
